var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pupophHintOverlayer",
      on: {
        touchmove: function($event) {
          $event.preventDefault()
        }
      }
    },
    [
      _c("div", { staticClass: "pupophHint" }, [
        _c("div", { staticClass: "pupophHintTop" }, [_vm._t("title")], 2),
        _vm._v(" "),
        _c("div", { staticClass: "pupophHintBottom" }, [
          _c("span", { staticClass: "cancel", on: { click: _vm.cancelHint } }, [
            _vm._v("取消")
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "sure", on: { click: _vm.sureBtn } }, [
            _vm._v("确认")
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5264f9dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5264f9dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/common/pupopHint.vue
// module id = null
// module chunks = 